export default __webpack_public_path__ + "static/media/inspector-text-align-middle.c7051a7d.svg";